export default function unpublishedAudit(entryId, initialAudit) {
  return {
    ...(typeof window !== 'undefined' && typeof window.transcriptEditorMixin === 'function'
      ? window.transcriptEditorMixin()
      : {}),
    entryId,
    open: false,
    activeStep: initialAudit.videoReviewed ? 'submission' : 'video',
    audit: initialAudit,
    details: null,
    rows: {},
    loading: false,
    busy: false,
    error: '',
    notes: '',
    reviewed: false,
    showDeletionForm: false,
    wrongText: '',
    rightText: '',
    correctionReported: false,
    row(id) {
      if (!this.rows[id]) {
        this.rows[id] = { cues: [], chapters: [], currentTime: 0 };
      }
      return this.rows[id];
    },
    async toggle() {
      this.open = !this.open;
      if (this.open && !this.details) await this.load();
    },
    async load() {
      if (this.loading || this.busy) return;
      this.loading = true;
      this.error = '';
      try {
        const response = await fetch(`/author-queue/audit-details?entryId=${this.entryId}`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'Could not check this video.');
        const previousStatus = this.audit.status;
        this.details = result;
        this.audit = result.audit;
        if (typeof this.parseSrt === 'function') {
          this.row(this.entryId).cues = this.parseSrt(result.transcriptSrt || '');
        }
        this.activeStep = this.audit.videoReviewed ? 'submission' : 'video';
        this.reviewed = false;
        if (previousStatus !== this.audit.status) window.location.reload();
      } catch (error) {
        this.error = error.message || 'Could not check this video.';
      } finally {
        this.loading = false;
      }

    },
    async decide(decision) {
      if (this.busy || this.loading) return;
      if (decision === 'delete' && !this.notes.trim()) {
        this.error = 'Explain why this video should be deleted, including any duplicate you found.';
        return;
      }
      if (decision === 'video-reviewed' && this.details?.media.state !== 'available') return;
      if (decision === 'transcript-reviewed' && !this.reviewed) return;
      this.busy = true;
      this.error = '';
      try {
        const response = await fetch('/author-queue/audit-decision', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-CSRF-Token': window.csrfToken || '' },
          body: JSON.stringify({
            entryId: this.entryId, decision, notes: this.notes,
            transcriptHash: this.details?.transcriptHash || '',
          }),
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'Could not save this audit decision.');
        this.audit = result.audit;
        if (decision === 'video-reviewed') {
          this.activeStep = 'submission';
          this.showDeletionForm = false;
        } else if (decision === 'transcript-reviewed') {
          this.reviewed = false;
        } else {
          window.location.reload();
        }
      } catch (error) {
        this.error = error.message || 'Could not save this audit decision.';
      } finally {
        this.busy = false;
      }
    },
    async reportCorrection() {
      if (this.busy || this.loading) return;
      if (!this.wrongText.trim() || !this.rightText.trim()) {
        this.error = 'Enter both the incorrect and correct transcript text.';
        return;
      }
      this.busy = true;
      this.error = '';
      this.correctionReported = false;
      try {
        const response = await fetch('/video-submission/report-transcript-correction', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-CSRF-Token': window.csrfToken || '' },
          body: JSON.stringify({ entryId: this.entryId, wrongText: this.wrongText, rightText: this.rightText }),
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'Could not report the transcript correction.');
        this.correctionReported = true;
        this.reviewed = false;
        this.audit.transcriptReviewed = false;
      } catch (error) {
        this.error = error.message || 'Could not report the transcript correction.';
      } finally {
        this.busy = false;
      }
    },
  };
}

export function unpublishedDeletionReview(entryId) {
  return {
    busy: false,
    error: '',
    notes: '',
    async review(decision) {
      if (this.busy) return;
      if (decision === 'archive' && !(await window.ttConfirm('Archive this unpublished video in Wistia instead of deleting it? The Craft record will be retained, and the media can be restored in Wistia later.'))) return;
      if (decision === 'approve' && !(await window.ttConfirm('Delete this unpublished Craft record? Its Wistia media will also be deleted unless another Craft record uses it. This is a permanent cleanup action.'))) return;
      this.busy = true;
      this.error = '';
      try {
        const response = await fetch('/author-queue/review-deletion', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-CSRF-Token': window.csrfToken || '' },
          body: JSON.stringify({ entryId, decision, notes: this.notes }),
        });
        const result = await response.json();
        if (!response.ok || !result.success) throw new Error(result.message || 'Could not resolve this deletion request.');
        window.location.reload();
      } catch (error) {
        this.error = error.message || 'Could not resolve this deletion request.';
      } finally {
        this.busy = false;
      }
    },
  };
}
